export default __webpack_public_path__ + "static/media/logo_white.5913ac5c.png";